import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-cards";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import { EffectCards, Autoplay, Navigation } from "swiper/modules";

import "./styles.css";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";

export default function SwiperSlide1({ images, dummyData, setContent }) {
  const swiperRef = useRef(null);
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  // function handleSlideChange(swiper) {
  //   const activeIndex = swiper.activeIndex;
  //   setContent(dummyData[activeIndex]);
  // }

  // function handlePrevClick() {
  //   if (swiperRef.current && swiperRef.current.slidePrev) {
  //     swiperRef.current.slidePrev();
  //   }
  // }

  // function handleNextClick() {
  //   if (swiperRef.current && swiperRef.current.slideNext) {
  //     swiperRef.current.slideNext();
  //   }
  // }

  function handleSlideChange(swiper) {
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
    setContent(dummyData[swiper.activeIndex]);
  }

  function handlePrevClick() {
    if (swiperRef.current && !isBeginning) {
      swiperRef.current.slidePrev();
    }
  }

  function handleNextClick() {
    if (swiperRef.current && !isEnd) {
      swiperRef.current.slideNext();
    }
  }

  return (
    <div className="swiper-container relative">
      <Swiper
        effect={"cards"}
        grabCursor={true}
        centeredSlides={true}
        loop={false}
        modules={[EffectCards, Autoplay, Navigation]}
        className="mySwiper"
        onSlideChange={handleSlideChange}
        direction="horizontal"
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
          reverseDirection: true,
        }}
        speed={800}
        touchRatio={1.5}
        // onSwiper={(swiper) => {
        //   swiperRef.current = swiper;
        // }}
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
          setIsBeginning(swiper.isBeginning);
          setIsEnd(swiper.isEnd);
        }}
      >
        {/* {images.map((img, index) => (
          <SwiperSlide key={index}>
            <img src={img} alt={`Slide ${index}`} className="swiper-image" />
          </SwiperSlide>
        ))} */}
        {dummyData?.map(({ background }, index) => (
          <SwiperSlide key={index}>
            <img
              src={background}
              alt={`Slide ${index}`}
              className="swiper-image"
              loading="lazy"
            />
          </SwiperSlide>
        ))}
      </Swiper>
      {/* Custom Navigation Buttons with Icons */}
      {/* <div className="hidden md:flex border items-center justify-between absolute left-1/2 transform -translate-x-1/2 cursor-pointer bottom-[-4vw] text-white gap-x-[1.24vw]">
        <button
          onClick={handlePrevClick}
          disabled={isBeginning}
          className={`p-2 rounded-full absolute top-1/2 ${
            isBeginning ? "opacity-50 cursor-not-allowed" : ""
          }`}
        >
          <BsArrowLeft size={30} className="text-white" />
        </button>

        <button
          onClick={handleNextClick}
          disabled={isEnd}
          className={`p-2 rounded-full ${
            isEnd ? "opacity-50 cursor-not-allowed" : ""
          }`}
        >
          <BsArrowRight size={30} className="text-white" />
        </button>
      </div> */}

      <button
        onClick={handlePrevClick}
        disabled={isBeginning}
        className={`p-2 rounded-full hidden md:block absolute top-1/2 -translate-x-[150%] 3xl-plus:-translate-x-[200%] -translate-y-1/2 ${
          isBeginning ? "opacity-50 cursor-not-allowed" : ""
        }`}
      >
        <BsArrowLeft size={30} className="text-white" />
      </button>

      <button
        onClick={handleNextClick}
        disabled={isEnd}
        className={`p-2 rounded-full hidden md:block absolute top-1/2 right-0 translate-x-[150%] 3xl-plus:translate-x-[200%] -translate-y-1/2 ${
          isEnd ? "opacity-50 cursor-not-allowed" : ""
        }`}
      >
        <BsArrowRight size={30} className="text-white" />
      </button>
    </div>
    // </div>
  );
}
